import "../style.css";
import { useEffect, useState } from "react";
import { io } from "socket.io-client";

const API_URL = process.env.REACT_APP_API_URL || "/api";
const REALTIME_ENABLED = !API_URL.startsWith("/api");
const socketHost = API_URL.startsWith("http") ? API_URL : window.location.origin;
const socket = REALTIME_ENABLED
  ? io(socketHost, {
      transports: ["websocket"]
    })
  : null;


export default function SlotBooking() {
  const [stations, setStations] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const clientName = localStorage.getItem("clientName") || "Client";
  const clientEmail = localStorage.getItem("clientEmail") || "client@local";

useEffect(() => {
  fetch(`${API_URL}/stations`)
    .then(res => res.json())
    .then(setStations);

  if (socket) {
    socket.on("connect", () => {
      console.log("Socket connected:", socket.id);
    });

    socket.on("update", data => {
      setStations(data);
    });
  }

  return () => {
    if (socket) {
      socket.off("update");
    }
  };
}, []);



  const book = async (id) => {
    const res = await fetch(`${API_URL}/book`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        stationId: id,
        clientName,
        clientEmail
      })
    });

    if (res.ok) {
      setShowPopup(true);

      // auto close after 2 seconds
      setTimeout(() => setShowPopup(false), 2000);
    }
  };

  return (
    <div className="booking-container">
      <h1>Slot Booking</h1>

      {stations.map(s => (
        <div className="station-card" key={s._id}>
          <h2>{s.name} — {s.location}</h2>
        <p>Price: ₹{s.pricePerHour}/hr</p>

          <div className="slot-grid">
            {[...Array(s.totalSlots)].map((_, i) => {
              const occupied = i < s.occupiedSlots;

              return (
                <div
                  key={i}
                  className={`slot ${occupied ? "occupied" : "available"}`}
                  onClick={() => !occupied && book(s._id)}
                >
                  Slot {i + 1}
                  <small>{occupied ? "Occupied" : "Available"}</small>
                </div>
              );
            })}
          </div>
        </div>
      ))}

      {/* POPUP MODAL */}
      {showPopup && (
        <div className="popup-overlay">
          <div className="popup-box">
            <h2> Slot Booked Successfully!</h2>
            <button onClick={() => setShowPopup(false)}>OK</button>
          </div>
        </div>
      )}
    </div>
  );
}
